import gameSerializer from '@serializers/gameSerializer.js'
import { readonly, ref } from 'vue'

const gameRef = ref(undefined)

export default function () {
  function getPublicGame(refresh = false) {
    if (!gameRef.value || refresh) {
      gameRef.value = globalThis.GAME
        ? gameSerializer.transform(globalThis.GAME)
        : null
    }
    return readonly(gameRef)
  }

  // Stub for shared components
  function getFeaturedGames() {
    return { value: null }
  }

  return {
    getFeaturedGames,
    getPublicGame,
  }
}
